// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.articletypes', {
        url: '/articletypes?searchTerm',
        views: {
            'baseList@base': {
                templateUrl: 'main/base/articletypes/articletypes.tpl.html',
                controller: 'ArticleTypesController as vm'
            }
        },
        resolve: {
            articleTypes: articleTypesResolver,
            searchTerm: searchTermResolver
        }
    });
}


// @ngInject
function articleTypesResolver(ArticleTypesApiService, $stateParams) {
    return ArticleTypesApiService.getAll($stateParams.searchTerm);
}

// @ngInject
function searchTermResolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function ArticleTypesController($rootScope, $state, articleTypes, $scope, ArticleTypesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    //Properties
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.articleTypes = articleTypes;
    vm.selectedArticleTypeId = 0;

    //Methods
    vm.searchTermChanged = searchTermChanged;

    activate();

    function activate() {
        $rootScope.$on('ArticleType.Changed', function () {
            loadArticleTypes();
        });
    }
    function searchTermChanged() {
        loadArticleTypes();
    }

    function loadArticleTypes() {
        loadSpinnerService.start('mainSpinner');
        ArticleTypesApiService.getAll(vm.searchTerm).then(function (response) {
            vm.articleTypes = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

}

angular
    .module('base.articletypes', ['articletypes.api','articletypes.articletype'])
    .config(stateConfig)
    .controller('ArticleTypesController', ArticleTypesController);
